// @flow
import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config
  };
};

class SharingSettings extends React.Component {
  constructor(props) {
    super(props);

    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  // #endregion
  render() {
    const { config } = this.props;

    return (
      <Section title="Sharing settings">
        <Section title="Email information" subsection>
          <FormGroup row>
            <Label for="templateId" sm={2}>
              Template ID
            </Label>
            <Col sm={10}>
              <Input
                value={config.templateId}
                type="text"
                name="templateId"
                required
                id="templateId"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
        </Section>
        <Section title="Facebook information" closed subsection>
          <FormGroup row>
            <Label for="pageId" sm={2}>
              Album ID
            </Label>
            <Col sm={10}>
              <Input
                value={config.pageId}
                type="text"
                name="pageId"
                id="pageId"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="appId" sm={2}>
              App ID
            </Label>
            <Col sm={10}>
              <Input
                value={config.appId}
                type="text"
                name="appId"
                id="appId"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="appSecret" sm={2}>
              App secret
            </Label>
            <Col sm={10}>
              <Input
                value={config.appSecret}
                type="text"
                name="appSecret"
                id="appSecret"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="facebookToken" sm={2}>
              Facebook token
            </Label>
            <Col sm={10}>
              <Input
                value={config.facebookToken}
                type="text"
                name="facebookToken"
                id="facebookToken"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
        </Section>
        <Section title="Other" subsection>
        <FormGroup row>
          <Label for="customFields" sm={2}>
            Custom Fields
          </Label>
          <Col>
            <Input
              value={config.customFields}
              sm={2}
              placeholder="One field per line"
              type="textarea"
              name="customFields"
              id="customFields"
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>
        </Section>

      </Section>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SharingSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/SharingSettings.jsx